
import { GenericTable } from './GenericTable';
import { programsColumns } from '../../constants/tableRows';

type RowData = Record<string, React.ReactNode>;

export function ProgramsTable({ data, onEdit, onAdd }: { 
  data: RowData[]; 
  onEdit?: (row: RowData) => void;
  onAdd?: () => void;
}) {
  return (
    <>
      <GenericTable columns={programsColumns} data={data} title='programs' onEdit={onEdit} />
    </>
  );
}